<template>
<div class="testimonial hero section is-paddingless" v-if="bg && section_data.testimonials">
    <div :class="['hero-body']" :style="'background-image: url(' + bg + ');'">
        <div class="container has-text-centered">
            <header class="section-header in-testimonial">
                <h2 class="title is-2 has-text-white">{{section_data.title}}</h2>
                <span><i></i><i></i><i></i></span>
            </header>
            <agile :navButtons="false">
                <div v-for="item in section_data.testimonials" class="slide">
                    <div class="testimonial__item">
                        <div class="content" v-html="item.content"></div>
                        <p class="title is-5 has-text-white-ter">{{item.title}}</p>
                        <p class="subtitle is-7 has-text-white-ter">{{item.subtitle}}</p>
                    </div>
                </div>
            </agile>
        </div>
    </div>
</div>
</template>

<script>
import { VueAgile } from 'vue-agile';
import PosHandler from '../../mixins/PosHandler';
export default {
    name        :   'TestimonialSection',
    props       :   ['section_data', 'is_mobile'],
    components  :   { agile: VueAgile },
    mixins      :   [ PosHandler ],
    computed    :   {
        bg()
        {
            if (this.section_data && this.section_data.hero) {
                return this.section_data.hero.url;
            }

            return null;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/sections/TestimonialSection.vue